export interface ITeacher {
  user_id: string;
  first_name: string;
  last_name: string;
  profile: ITeacherProfile;
  lesson_profile: ITeacherLessonProfile;
}

export interface ITeacherBasic {
  user_id: string;
  first_name: string;
  last_name: string;
}

export interface ITeacherProfileInCourse {
  title: string;
  picture: string;
}

export interface ITeacherInfoInCourse {
  user_id: string;
  first_name: string;
  last_name: string;
  profile: ITeacherProfileInCourse;
}

export interface IStudentBasic {
  user_id: string;
  first_name: string;
  last_name: string;
}

export interface IStudentInfoInCourse {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  last_login: string | null;
  profile: { school: string; phone_number: string };
}

export interface ITeacherProfile {
  phone_number: string;
  title: string;
  experience: string;
  remark: string;
  picture: string;
  subjects: ISubject[];
}

export interface ITeacherLessonProfile {
  phone_number: string;
  remark: string;
  picture: string;
  hidden: boolean;
  subjects: ISubject[];
}

export interface ICourseFile {
  id: number;
  name: string;
}

export interface ICourse {
  id: number;
  title: string;
  description: string;
  times: string;
  teachers: ITeacherInfoInCourse[];
  students: IStudentInfoInCourse[];
  subject: ISubject;
  news: ICourseNews[];
  teachers_count: number;
  students_count: number;
  subject_count: number;
  created_at: string;
  updated_at: string;
  files: ICourseFile[];
}

export interface ICourseNews {
  id: number;
  course: number;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface ICourseCreateRequest {
  course: number;
  title: string;
  content: string;
}

export enum SubjectKind {
  PREPARATION = "PREPARATION",
  LESSON = "LESSON",
}

export interface ISubjectPrice {
  id: number;
  duration: number;
  price: string;
}

export interface ISubject {
  id: number;
  name: string;
  picture: string | null;
  prep_price?: string;
  prices?: ISubjectPrice[];
  kind: SubjectKind;
}

export interface ISubjectCreateRequest {
  name: string;
}

export interface IAppointment {
  id: number;
  meet_url: string;
  text: string;
  start: string;
  end: string;
  course: number;
}

export interface IOrderCourseInfo {
  id: number;
  title: string;
}

export interface IOrder {
  id: string;
  course: IOrderCourseInfo;
  calendar: number | null;
  created_at: string;
  updated_at: string;
  amount: string;
  paid: boolean;
  date_paid: string | null;
  info: string;
  status: string;
  customer: IStudentInfoInCourse;
}

export type Term = {
  id: number;
  start: string;
  end: string;
  status: string;
  teacher: {
    user_id: string;
    first_name: string;
    last_name: string;
    email: string;
    lesson_profile: ITeacherLessonProfile;
  };
  student: {
    first_name: string;
    last_name: string;
    email: string;
  };
  meet_url: string | null;
  remark: string;
  subject: {
    name: string;
  };
};
